import Quill from 'quill';
import 'quill/dist/quill.snow.css';
import React, { useEffect, useRef } from 'react';

export interface TnTextEditorProps {
  style?: any;
  value: string;
  onTextChange: (value: string) => void;
  disabled?: boolean;
  title?: string;
}

const TnTextEditor = ({ value, onTextChange, disabled, title }: TnTextEditorProps) => {
  const editorRef = useRef<any>();
  const quillRef = useRef<any>();

  useEffect(() => {
    if (editorRef.current) {
      const icons = Quill.import('ui/icons');
      icons['undo'] = `<svg viewbox="0 0 18 18">
        <polygon class="ql-fill ql-stroke" points="6 10 4 12 2 10 6 10"></polygon>
        <path class="ql-stroke" d="M8.09,13.91A4.6,4.6,0,0,0,9,14,5,5,0,1,0,4,9"></path>
      </svg>`;
      icons['redo'] = `<svg viewbox="0 0 18 18">
        <polygon class="ql-fill ql-stroke" points="12 10 14 12 16 10 12 10"></polygon>
        <path class="ql-stroke" d="M9.91,13.91A4.6,4.6,0,0,1,9,14a5,5,0,1,1,5-5"></path>
      </svg>`;

      quillRef.current = new Quill(editorRef.current, {
        theme: 'snow',
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic'],
              [{ color: [] }],
              [{ align: [] }],
              [{ list: 'ordered' }, { list: 'bullet' }],
              [{ indent: '-1' }, { indent: '+1' }],
              [{ undo: 'undo' }, { redo: 'redo' }],
            ],
            handlers: {
              redo() {
                quillRef.current.history.redo();
              },
              undo() {
                quillRef.current.history.undo();
              },
            },
          },
        },
      });

      if (disabled) {
        quillRef.current.disable();
      }

      if (value) {
        const delta = quillRef.current.clipboard.convert(value);

        quillRef.current.setContents(delta, 'silent');
      }

      quillRef.current.on('text-change', (_delta: any, _oldDelta: any, source: string) => {
        if (source === 'user') {
          onTextChange?.(quillRef.current.root.innerHTML);
        }
      });
    }
  }, []);

  useEffect(() => {
    if (quillRef.current && disabled) {
      quillRef.current.disable();
    }
  }, [disabled]);

  useEffect(() => {
    if (quillRef.current && value) {
      if (quillRef.current.root.innerHTML !== value) {
        const delta = quillRef.current.clipboard.convert(value);

        quillRef.current.setContents(delta, 'silent');
      }
    }
  }, [value]);

  return (
    <div style={{ display: 'block' }}>
      <div data-testid={title} ref={editorRef} style={{ backgroundColor: 'rgba(33, 33, 33, 0.08)', minHeight: 200 }} />
    </div>
  );
};

export default TnTextEditor;
